<template>
  <BModal
    :modal-name="modalName"
    :width="modalWidth"
    :height="modalHeight"
  >
    <BHeightAdjuster>
      <BModalHeader
        :title="$t('leadView.title')"
        @modal-close="$modal.hide(modalName)"
      />
      <BModalBody v-loading="$wait.is('updateLeadViewWait')">
        <BLayout
          class="mt-600"
          column
        >
          <BListItem>
            <template #header>
              <div>{{ $t('leadView.name' ) }}</div>
            </template>
            <BInput
              v-model="leadViewName"
              v-model:valid="valid"
              autofocus
              :rules="[requiredRule]"
            />
          </BListItem>
          <BListItem class="mt-200">
            <template #header>
              <div>{{ $t('leadView.description' ) }}</div>
            </template>
            <BTextarea
              v-model="leadViewDescription"
              resize="none"
              :autosize="{ minRows: 4, maxRows: 10 }"
            />
          </BListItem>
          <BListItem class="mt-200">
            <template #header>
              <span>{{ $t('leadView.owner') }}</span>
            </template>
            <SelectUser
              v-model="ownerId"
              :use-all="false"
              clearable
              placement="top"
            />
          </BListItem>
        </BLayout>
      </BModalBody>
      <BModalFooter>
        <BLayout
          class="mt-200"
          justify-center
        >
          <BBtn
            type="primary"
            :disabled="!valid"
            :loading="$wait.is('updateLeadViewWait')"
            @click="handleUpdateLeadView"
          >
            {{ $t('general.update.text') }}
          </BBtn>
        </BLayout>
      </BModalFooter>
    </BHeightAdjuster>
  </BModal>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { useUsers } from '@/composable/user/user/users';
import errorHandler from '@/mixins/error_handler';
import inputValidation from '@/mixins/input_validation';
import SelectUser from '@/plugins/biscuet-materials/components/molecules/SelectUser.vue';

export default {
  components: {
    SelectUser,
  },
  mixins: [inputValidation, errorHandler],
  props: {
    leadView: Object,
    modalName: String,
  },
  emits: ['afterUpdate'],
  setup() {
    const { activeUsers } = useUsers();
    return {
      activeUsers,
    };
  },
  data () {
    return {
      valid: false,
      leadViewName: '',
      leadViewDescription: '',
      ownerId: null,
      modalWidth: '580px',
      modalHeight: '580px',
    };
  },
  watch: {
    leadView(value) {
      if (!value) return;
      this.leadViewName = value.name;
      this.leadViewDescription = value.description;
      this.ownerId = value.owner?.id;
    },
  },
  methods: {
    ...mapWaitingActions('user', {
      updateLeadViewAction: 'updateLeadViewWait',
    }),
    handleUpdateLeadView () {
      this.updateLeadViewAction({
        leadViewId: this.leadView.id,
        body: {
          name: this.leadViewName,
          description: this.leadViewDescription,
          ownerId: this.ownerId || null,
        },
        errorHandlers: {
          422: this.defaultHandler,
        },
      }).then(() => {
        this.$modal.hide(this.modalName);
        this.$emit('afterUpdate');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.select-user .type-select) {
  width: 100%;
}
:deep(.select-user .el-popper) {
  width: 100%;
}
</style>
